module.exports = __webpack_public_path__ + "static/media/1-roup-2-3-x.eac165e8.png";